import React, { ReactNode } from "react";
import styled from "styled-components";

export interface V3PageShellProps {
  children: ReactNode;
  as?: keyof JSX.IntrinsicElements;
  className?: string;
  testID?: string;
}

const Shell = styled.div`
  min-height: 100vh;
  width: 100%;
  background: ${({ theme }) => theme.colors.ui.background.page};
  color: ${({ theme }) => theme.colors.ui.text.primary};
`;

export const V3PageShell = ({
  children,
  as = "div",
  className,
  testID = "v3-page-shell",
}: V3PageShellProps): JSX.Element => (
  <Shell as={as} className={className} data-testid={testID}>
    {children}
  </Shell>
);
